<template>
  <div id="sb-footer ">
    <div class="gray-550 f-90 d-flex flex-column flex-sm-row justify-content-between footer mb-3">
      <div class="text-white mr-2">powered by</div>
      <a href="https://qesg.co.kr/" style="color: #c883ff">ESG Reporting Tool</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'sbFooter',
  };
</script>

<style scoped>
  #sb-footer {
    position: relative;
    width: 100%;
    z-index: 1000;
    margin-bottom: 1rem;
  }
</style>
